import React from 'react';

export function SecProgressBar({seconds}: {seconds: number}): React.ReactElement {
  const width = (seconds / 60) * 100;

  return <div className="sec-progress" style={{width: `${width}%`}} />;
}
